import moment, { type Moment } from 'moment'
import { type IPP_SUPPORTED_LOCALE } from '@retailer-platform/shared-components'

const dateFormat = 'YYYY-MM-DD'

/**
 * Checks if the provided string matches the expected dateFormat.
 *
 * @param dateString the string date to test
 * @returns a bool
 */
const isValidDateFormat = dateString => moment(dateString, dateFormat, true).isValid()

/**
 * Safely converts a string into a Moment, if it matches the expected dateFormat, otherwise returns undefined.
 *
 * @param dateString the string date to attempt parsing
 * @returns a Moment or undefined
 */
const stringToMoment = dateString =>
  isValidDateFormat(dateString) ? moment(dateString) : undefined

export const MomentDateParam = {
  encode: (momentDate: Moment) => momentDate.format(dateFormat),
  decode: (dateString: string | string[]) => {
    if (Array.isArray(dateString)) {
      throw new Error('Invalid type')
    }
    return stringToMoment(dateString)
  },
}

export const loadMomentLocale = async (locale: IPP_SUPPORTED_LOCALE) => {
  switch (locale) {
    case 'es-ES':
      try {
        // @ts-ignore - moment/dist/locale/es does in fact exist
        await import('moment/dist/locale/es')
        moment.locale('es')
      } catch {
        moment.locale('en')
      }
      break
    case 'fr-FR':
      try {
        // @ts-ignore - moment/dist/locale/fr does in fact exist
        await import('moment/dist/locale/fr')
        moment.locale('fr')
      } catch {
        moment.locale('en')
      }
      break
    case 'en-US':
    default:
      moment.locale('en')
      break
  }
}
